(function () {
    'use strict';

    angular.module("imApp").factory("batchDelReceiveLinesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1594,
                    parameters: parms || {}
                });
            },
            listReceiveLines: function (parms) {
                return $ihttp.post({
                    method: 1595,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
